import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/modals/wallet/methods';

import CashappMerchantDeposit from './cashapp-merchant-deposit/index';
import CashappDeposit from './cashapp-deposit/index';
import CashappCashout from './cashapp-cashout/index';
import CryptoDeposit from './crypto-deposit/index';
import CardsDeposit from './cards-deposit/index';
import CashCardsDeposit from './cash-cards-deposit/index';
import ChimeDeposit from './chime-deposit/index';
import ChimeCashout from './chime-cashout/index';
import ZelleDeposit from './zelle-deposit/index';
import CashAppP2PDeposit from './cashapp-p2p-deposit/index';
import ApplePayDeposit from './applepay-deposit';
import GooglePayDeposit from './googlepay-deposit';
import PayPalDeposit from './paypal-deposit';

export default () => {
    const {method} = useSelector(Selector);

    if(method === 'chime-deposit') return <ChimeDeposit />
    if(method === 'chime-cashout') return <ChimeCashout />
    if(method === 'cashapp-merchant-deposit') return <CashappMerchantDeposit />
    if(method === 'cashapp-deposit') return <CashappDeposit />
    if(method === 'cashapp-cashout') return <CashappCashout />
    if(method === 'crypto-deposit') return <CryptoDeposit />
    if(method === 'cards-deposit') return <CardsDeposit />
    if(method === 'cash-cards-deposit') return <CashCardsDeposit />
    if(method === 'zelle-deposit') return <ZelleDeposit />
    if(method === 'cashapp-p2p-deposit') return <CashAppP2PDeposit />
    if(method === 'applepay-deposit') return <ApplePayDeposit />
    if(method === 'googlepay-deposit') return <GooglePayDeposit />
    if(method === 'paypal-deposit') return <PayPalDeposit />
    return <></>;
}